import jsCookie from 'js-cookie';
import { getDomain } from 'tldjs';

import * as Cookies from '../constants/cookies';

// Getter function to avoid accessing window.SS_GLOBALS at module load time (Vite timing issue)
const getCookieOptions = () => ({
  secure: window.SS_GLOBALS.frontEndConfig.forceSSL,
  sameSite: window.SS_GLOBALS.frontEndConfig.forceSSL ? 'None' : 'Lax',
});

class CookieServiceClass {
  getCookieValue(key) {
    return jsCookie.get(key);
  }

  setCookieValue(key, value, path) {
    return jsCookie.set(key, value, path);
  }

  setCookieValueWithPathAndDomain(key, value) {
    return jsCookie.set(key, value, {
      path: '/',
      domain: this.getCookieDomain(),
      ...getCookieOptions(),
    });
  }

  setCookieValueWithExpiration(key, value, expirationInDays) {
    return jsCookie.set(key, value, {
      path: '/',
      domain: this.getCookieDomain(),
      expires: expirationInDays,
      ...getCookieOptions(),
    });
  }

  setCookieValueWithExpirationInMinutes(key, value, expirationInMinutes) {
    const minutesInDay = 1440;
    return this.setCookieValueWithExpiration(key, value, expirationInMinutes / minutesInDay);
  }

  getCookieDomain() {
    const host = window.location.host || '';
    if (!host) {
      return;
    }
    const domain = getDomain(host);
    return !domain || domain.toLowerCase() === 'localhost' ? undefined : domain;
  }

  removeCookie(key, cookieDomain = null) {
    const cookieDomainWithFallback = cookieDomain || this.getCookieDomain();
    jsCookie.remove(key);
    jsCookie.remove(key, {
      domain: cookieDomainWithFallback,
      path: '/',
    });
  }

  removeV3Config() {
    this.removeCookie(Cookies.SSHome);
    this.removeCookie(Cookies.V3Access);
  }

  removeAuthentication(softLogout = false) {
    this.removeCookie('_auth_flow');
    this.removeCookie(Cookies.Auth0IsAuthenticated);
    this.removeCookie(Cookies.getAuth0IsClientAuthenticated());
    this.removeCookie(Cookies.Auth0IsLogin);
    this.removeCookie(Cookies.getLegacyAuth0IsClientAuthenticated());

    if (softLogout) return;

    this.removeCookie(Cookies.AccessTokenV2);
    this.removeCookie(Cookies.AccessTokenV3);
    this.removeCookie(Cookies.LegacyAuth);
    this.removeImpersonation();
  }

  removeImpersonation() {
    this.removeCookie(Cookies.Impersonation);
    this.removeCookie(Cookies.ImpersonationExpires);
  }
}

export const CookieService = new CookieServiceClass();
